/**
 * Copyright (c) 2024, Ouster, Inc.
 * All rights reserved.
 */
import { action, Action as EzPzAction } from 'easy-peasy';

export type UploadModalStatus = 'INACTIVE' | 'ACTIVE_MAX' | 'ACTIVE_MIN';

export type State = {
  isOpen: boolean;
  uploadModalStatus: UploadModalStatus;
  isPublicWarningOpen: boolean;
};

export const defaultState: State = {
  isOpen: false,
  uploadModalStatus: 'INACTIVE',
  isPublicWarningOpen: false,
};

export interface RecordingUploadModel extends State {
  setIsOpen: EzPzAction<RecordingUploadModel, boolean>;
  setUploadModalStatus: EzPzAction<RecordingUploadModel, UploadModalStatus>;
  setIsPublicWarningOpen: EzPzAction<RecordingUploadModel, boolean>;
}

export const modal: RecordingUploadModel = {
  ...defaultState,
  setIsOpen: action((state, isOpen) => {
    state.isOpen = isOpen;
  }),
  setIsPublicWarningOpen: action((state, isOpen) => {
    state.isPublicWarningOpen = isOpen;
  }),
  setUploadModalStatus: action((state, status) => {
    state.uploadModalStatus = status;
  }),
};
